import { type InputHTMLAttributes, type ReactNode, forwardRef } from "react";
import { cn } from "@/shared/lib/cn";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
};

export const Field = forwardRef<HTMLInputElement, Props>(function Field(
  { label, hint, error, className, ...rest },
  ref,
) {
  return (
    <label className={cn("flex flex-col gap-1.5", className)}>
      {label && (
        <span className="text-[11px] font-display font-bold uppercase tracking-[0.07em] text-ink-40">
          {label}
        </span>
      )}
      <input
        ref={ref}
        className={cn(
          "h-11 px-4 rounded-md border border-ink-12 bg-white text-ink text-[15px] placeholder:text-ink-40 focus:border-ink focus:outline-none transition-colors",
          error && "border-danger",
        )}
        {...rest}
      />
      {hint && !error && <span className="text-[12px] text-ink-60">{hint}</span>}
      {error && <span className="text-[12px] text-danger">{error}</span>}
    </label>
  );
});
